export default __webpack_public_path__ + "static/media/NYFWxWeb3-NRVLD_CROWNVNV2.31c616b8.png";